import {lazy} from 'react';
import GenericFallbackSuspense from '../../../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';

const OpenpayOverlayBody = lazy(() => import('./OpenpayOverlayBody'/* webpackChunkName: 'OpenpayOverlayBody' */));

export default function OpenpayOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <OpenpayOverlayBody />
    </GenericFallbackSuspense>
  );
}
